export const OrderStatus = {
    "NEW": 0,
    "PROCESSING": 1,
    "COMPLETED": 2,
    "PARTIAL": 3,
    "CANCELLED": 4,
    "RECEIVED": 5
}